<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
========================================================================================== -->
<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ Object.entries(this.data).length === 2 ? "Adicionar Equivalência" : "Editar "+(key ==='_default' ? 'modalidade padrão' : key) }}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <div class="p-6">
        <vs-input :label="Object.entries(this.data).length === 2 ? 'Código de Envio' : ''" v-model="key" class="mt-5 w-full" name="equivalent-key" v-validate="'required'" :type="Object.entries(this.data).length === 2 ? '': 'hidden'" />
        <span class="text-danger text-sm" v-show="errors.has('key')">{{ errors.first('key') }}</span>
        <span v-if="Object.entries(this.data).length !== 2" class="text-description text-sm" v-show="!errors.has('key')">Pressione <code>TAB</code> no seu teclado para escolher a modalidade</span>
        <span v-if="Object.entries(this.data).length === 2" class="text-description text-sm" v-show="!errors.has('key')">Escreva o código e em seguida pressione <code>TAB</code> no seu teclado</span>
        <vs-select v-model="val" label="Se transforma em" class="mt-5 w-full" name="equivalent-value" v-validate="'required'">
          <vs-select-item :key="key" :value="key" :text="(typeof item === 'string' || item instanceof String ? '('+key+') '+item : '('+key+') '+item.descricao)" v-for="(item, key) in category_choices" /> 
        </vs-select>
        <span class="text-danger text-sm" v-show="errors.has('val')">{{ errors.first('val') }}</span>
      </div>
    </VuePerfectScrollbar>
    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">{{Object.entries(this.data).length === 2 ? 'Adicionar' : 'Editar'}}</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancelar</vs-button>
    </div>
  </vs-sidebar>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      if (Object.entries(this.data).length === 2) {
        let { services, equivalents } = JSON.parse(JSON.stringify(this.data))
        this.services = services
        this.equivalents = equivalents
        this.initValues()
        this.$validator.reset()
      } else {
        let { key, val, services, equivalents } = JSON.parse(JSON.stringify(this.data))
        this.key = key
        this.val = val
        this.services = services
        this.equivalents = equivalents


        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  data() {
    return {

      key: null,
      val: "",
      services: {},
      equivalents: {},




      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    category_choices() {
      let choices = {};
      if (this.data.services) {
        // console.log({services:this.data.services})
        choices = this.data.services;
      }

      //choices["_default"] = "";
      return choices;
    },
    isFormValid() {
      return !this.errors.any() && this.key && this.val
    }
  },
  methods: {
    initValues() {
      if (this.data.key) return
      this.key = null
      this.val = ""
    },
    submitData() {
      this.$validator.validateAll().then(result => {
        if (result) {

          this.$vs.loading();

          let dat = this.equivalents;

          if (dat)
            dat[this.key] = this.val;
          else {
            dat = {}
            dat[this.key] = this.val;
          }

          let info = JSON.parse(JSON.stringify(this.$store.getters['sigep/info']))
          info["equivalents"] = dat;

          delete info.remetente.valid;


          this.$store.dispatch("sigep/updateCreds", info)
            .then(() => {

              this.$vs.notify({
                title: 'Tudo ok!',
                text: 'Cadastro processado',
                color: 'success',
                iconPack: 'feather',
                icon: 'icon-check'
              })

              this.$emit('closeSidebar')
              this.initValues()
              this.$vs.loading.close();

            })
            .catch(() => {
              // console.error(err) 

              this.$vs.notify({
                title: 'Erro',
                text: 'Aconteceu um erro, tente novamente!',
                color: 'warning',
                iconPack: 'feather',
                icon: 'icon-alert-circle'
              })

              this.$vs.loading().close();

            })



        }
      })
    },

  },
  components: {
    VuePerfectScrollbar,
  }
}

</script>
<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}

</style>
